<template>
    <template v-if="contentIs(ORG_SETTINGS)">
        <i class="i-ph-caret-right"/>
        <i class="i-ph-wrench"/><div class="text-sm">Virksomhetsinnstillinger</div>
        <i class="i-ph-caret-right"/>
        <targeting-router-link class="crumb" :to="{...ORG_SETTINGS, queryValues: {tab: tab.key}}">
            {{ tab.title }}
        </targeting-router-link>
    </template>
</template>

<script setup lang="ts">

import {ORG_SETTINGS} from '@/org-settings'
import { TargetingRouterLink } from '@tritt/multipanel'
import {findTab} from '@/org-settings/tabs'
import {computed} from 'vue'
import {TabDefinition} from '@/tabs/TabDefinition.type'
import {PanelContent} from '@tritt/multipanel'


const props = defineProps({
    panelContent: {
        type: Object as () => PanelContent,
        required: true
    }
})

const tab = computed<TabDefinition>(() => findTab(props.panelContent.props?.tab || ''))

const contentIs = (content: PanelContent) => {
    return props.panelContent.componentName === content.componentName
}
</script>

<style scoped>

</style>